import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import { FiMail, FiLock, FiArrowLeft, FiLogIn } from 'react-icons/fi';
import './LoginPMB.css';

const LoginPMB = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await axios.post('/api/pmb/login', formData);
      
      // Store token in localStorage
      localStorage.setItem('pmb_token', res.data.data.token);
      localStorage.setItem('pmb_user', JSON.stringify(res.data.data.user));
      
      toast.success(res.data.message);
      navigate('/pmb/dashboard');
    } catch (error) {
      const message = error.response?.data?.message || 'Login gagal';
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-pmb-page">
      <div className="login-container">
        <div className="login-left">
          <div className="login-branding">
            <h1>PMB 2026</h1>
            <p>Penerimaan Mahasiswa Baru</p>
            <div className="branding-features">
              <div className="feature-item">
                <span className="check-icon">✓</span>
                <span>Pendaftaran Online 24/7</span>
              </div>
              <div className="feature-item">
                <span className="check-icon">✓</span>
                <span>Proses Cepat & Mudah</span>
              </div>
              <div className="feature-item">
                <span className="check-icon">✓</span>
                <span>Beasiswa Tersedia</span>
              </div>
            </div>
          </div>
        </div>

        <div className="login-right">
          <div className="login-form-wrapper">
            <Link to="/pmb" className="back-link">
              <FiArrowLeft /> Kembali ke Beranda
            </Link>

            <div className="login-header">
              <h2>Login</h2>
              <p>Masuk ke akun PMB Anda</p>
            </div>

            <form onSubmit={handleSubmit} className="login-form">
              <div className="form-group">
                <label>Email</label>
                <div className="input-with-icon">
                  <FiMail />
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="email@example.com"
                    required
                  />
                </div>
              </div>

              <div className="form-group">
                <label>Password</label>
                <div className="input-with-icon">
                  <FiLock />
                  <input
                    type="password"
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    placeholder="Masukkan password"
                    required
                  />
                </div>
              </div>

              <div className="form-options">
                <label className="remember-me">
                  <input type="checkbox" />
                  <span>Ingat saya</span>
                </label>
                <Link to="/pmb/forgot-password" className="forgot-link">
                  Lupa password?
                </Link>
              </div>

              <button type="submit" className="btn-submit" disabled={loading}>
                {loading ? 'Loading...' : (
                  <>
                    <FiLogIn /> Login
                  </>
                )}
              </button>

              <div className="form-footer">
                <p>Belum punya akun? <Link to="/pmb/register">Daftar Sekarang</Link></p>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPMB;
